/**
 * The chocked gear (decision 106), the same mark as the companion's icon and the favicon: the accent's
 * rounded tile, a white main gear leg (the trunnion, the strut, the drag brace) standing on the ground
 * with an amber chock against each side of the tyre, the aircraft parked and returned, ready for the
 * next pilot. The paths are the small-size cut of the master (`docs/brand/sharifly-symbol-small.svg`, a
 * 256 canvas, the favicon's drawing) at 74 % of the tile, its centre 2 % above the tile's for the
 * optical centre.
 */
export function BrandMark({ size = 28, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 256 256" aria-hidden="true" className={className}>
      <rect width="256" height="256" rx="56" fill="var(--color-accent)" />
      <g transform="translate(33.3 34.1) scale(0.74)">
        <rect x="100" y="12" width="56" height="16" rx="8" fill="#ffffff" />
        <rect x="114" y="20" width="28" height="112" fill="#ffffff" />
        <path fill="none" stroke="#ffffff" strokeWidth="14" strokeLinecap="round" d="M120 74 L74 32" />
        <path fill="#ffffff" fillRule="evenodd" d="M128 112 A48 48 0 1 1 127.9 112 Z M128 148 A12 12 0 1 0 128.1 148 Z" />
        <rect x="24" y="208" width="208" height="20" fill="#ffffff" />
        <path fill="#f4a62a" d="M95.4 208 A58 58 0 0 1 72.9 164 L47.5 208 Z M160.6 208 A58 58 0 0 0 183.1 164 L208.5 208 Z" />
      </g>
    </svg>
  );
}

/** The wordmark with the mark: "ShariFly" and, when asked, the line under it. */
export function Wordmark({ tagline, size = 44 }: { tagline?: string; size?: number }) {
  return (
    <div className="flex items-center gap-3" data-testid="wordmark">
      <BrandMark size={size} />
      <div className="flex flex-col leading-none">
        <span className="text-[1.6rem] font-bold tracking-tight">ShariFly</span>
        {tagline ? <span className="muted mt-1 hidden text-[1rem] sm:block">{tagline}</span> : null}
      </div>
    </div>
  );
}
